import React from 'react';
import { ITranslateProps, translate } from '../../../mixins/translate';
import { IconRemoveButton } from '../../common/iconButtons/IconRemoveButton';
import {
    PanelButtonLink,
    PanelButtons,
    PanelHeader,
    PanelTable,
    TableBody,
    TableData,
    TableHead,
    TableHeader,
    TableHeadRow,
    TableRow,
} from '../../elements';
import { ConditionDot } from '../../utils/ConditionDot';
import { Defect } from '../Interfaces/Defect';

interface IDefectListNenProps extends ITranslateProps {
    selectedDefect?: Defect | undefined;
    defects: Defect[];
    defectAddEdit: string;
    useCareScore: boolean;
    onEditDefect: (defect: Defect) => void;
    onRemoveDefect: (defect: Defect) => void;
    onAddDefectClicked: () => void;
}

class DefectListNen extends React.Component<IDefectListNenProps, Record<string, unknown>> {
    constructor(props: IDefectListNenProps) {
        super(props);

        this.state = {};
    }

    public override render() {
        return (
            <>
                <PanelHeader text={this.props.t('common.defects')} />
                <PanelTable hover={true}>
                    <TableHead>
                        <TableHeadRow>
                            <TableHeader>{this.props.t('common.defect')}</TableHeader>
                            <TableHeader>{this.props.t('defect.seriousness')}</TableHeader>
                            <TableHeader>{this.props.t('defect.intensity')}</TableHeader>
                            <TableHeader>{this.props.t('defect.extend')}</TableHeader>
                            <TableHeader>{this.props.t('survey.conditionScore')}</TableHeader>
                            {this.props.useCareScore && <TableHeader>{this.props.t('common.care')}</TableHeader>}
                            <TableHeader>&nbsp;</TableHeader>
                        </TableHeadRow>
                    </TableHead>
                    <TableBody>
                        {this.props.defects.map((defect) => (
                            <TableRow
                                key={defect.id}
                                isRowSelected={this.props.selectedDefect && defect.id === this.props.selectedDefect.id}
                                onClick={() => this.props.onEditDefect(defect)}
                            >
                                <td style={{ cursor: 'pointer' }}>{defect.name}</td>
                                <td style={{ cursor: 'pointer' }}>{defect.seriousness && this.props.t(`seriousness.level${defect.seriousness}`)} </td>
                                <td style={{ cursor: 'pointer' }}>{defect.intensity && this.props.t(`intensity.level${defect.intensity}`)} </td>
                                <td style={{ cursor: 'pointer' }}>{defect.extend && this.props.t(`extend.level${defect.extend}`)} </td>
                                <TableData>{defect.defectType !== 'Tekortkoming' && <ConditionDot value={defect.score} />}</TableData>
                                {this.props.useCareScore && (
                                    <TableData>{defect.defectType === 'Tekortkoming' && <ConditionDot value={defect.careScore} />}</TableData>
                                )}
                                <TableData>
                                    <IconRemoveButton onClick={() => this.props.onRemoveDefect(defect)} />
                                </TableData>
                            </TableRow>
                        ))}
                    </TableBody>
                </PanelTable>
                {this.props.defectAddEdit === 'hidden' && (
                    <PanelButtons>
                        <PanelButtonLink
                            onClick={() => this.props.onAddDefectClicked()}
                            text={this.props.t('common.addItem', this.props.t('common.defect'))}
                            icon="fa fa-plus"
                            primary={true}
                            small={true}
                        />
                    </PanelButtons>
                )}
            </>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default translate()(DefectListNen);
